import type { ReactElement } from 'react';
import { t } from '@fetmode/i18n';

import { RoxyMark } from './RoxyMark.js';
import { useRoxy } from './RoxyProvider.js';
import './RoxyNavBadge.css';

function statusLabel(listenEnabled: boolean, listening: boolean): string {
  if (!listenEnabled) {
    return t('common.studio.live.roxyOff');
  }
  return listening ? t('common.studio.live.roxyListening') : t('common.studio.live.roxyOn');
}

export function RoxyListenToggle(): ReactElement {
  const { listenEnabled, listening, supported, setListenEnabled } = useRoxy();
  const status = !listenEnabled ? 'off' : listening ? 'listening' : 'on';
  const label = statusLabel(listenEnabled, listening);

  return (
    <button
      type="button"
      className={`roxy-badge roxy-badge--${status}`}
      disabled={!supported}
      title={supported ? t('common.studio.roxy.badgeToggleHint') : t('common.studio.live.roxyUnsupported')}
      aria-pressed={listenEnabled}
      aria-label={label}
      onClick={() => {
        setListenEnabled(!listenEnabled);
      }}
    >
      <RoxyMark size={26} className="roxy-badge__mark" />
      <span className="roxy-badge__name">{label}</span>
    </button>
  );
}
